<template>
  <div>
    <Refund
      :refundDialog="refundDialog"
      :invoice="selectedInvoice"
      @closeRefund="closeRefund"
      @invoiceRefunded="invoiceRefunded"
    ></Refund>
    <v-card v-if="location">
      <v-toolbar class="elevation-0" height="45" color="gray">
        <v-toolbar-title>
          <h1 class="subheading">{{ $t("pageHeader.invoice") }}</h1>
        </v-toolbar-title>
        <v-btn
          color="teal"
          v-if="!location.isCanceled"
          dark="dark"
          small="small"
          absolute="absolute"
          bottom="bottom"
          right="right"
          fab="fab"
          :to="`/invoice/${location.storeID}/create`"
        >
          <v-icon>add</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-title>
        <v-flex xs12="xs12" md4="md4">
          <v-text-field
            v-model="search"
            append-icon="search"
            label="Search"
            single-line="single-line"
            hide-details="hide-details"
            clearable="clearable"
          ></v-text-field>
        </v-flex>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="invoice"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        ><template slot="items" slot-scope="props">
          <tr class="pointer">
            <td class="text-xs-left" @click="viewInvoice(props.item)">
              <span>{{ props.item.invoiceID }}</span>
              <v-chip
                class="ml-1"
                small="small"
                color="#D0E9FF"
                v-if="props.item.hasHardware"
              >
                <v-icon small="small" color="#3C4DA6">keyboard</v-icon>
              </v-chip>
              <v-chip
                class="ml-1"
                small="small"
                dark="dark"
                color="#d2f8d2"
                v-if="props.item.givenDay !== 0"
              >
                <v-icon small="small" color="green">access_time</v-icon
                ><span class="ml-1 green--text"
                  >{{ props.item.givenDay }}
                </span>
              </v-chip>
            </td>
            <td class="text-xs-left" @click="viewInvoice(props.item)">
              <span>{{
                $moment(props.item.createDateTime).format("MM/DD/YYYY")
              }}</span>
              <v-chip
                class="ml-1"
                small="small"
                color="#ffd0d2"
                v-if="props.item.refunded"
              >
                <v-icon small="small" color="red">replay</v-icon>
              </v-chip>
              <v-chip
                class="ml-1"
                small="small"
                color="#dde2e6"
                v-else-if="props.item.refundAmount &gt; 0"
              >
                <v-icon small="small" color="gray">replay</v-icon
                ><span class="gray--text">{{
                  props.item.refundAmount | currency
                }}</span>
              </v-chip>
            </td>
            <td
              class="text-xs-left"
              v-if="props.item.paidDateTime"
              @click="viewInvoice(props.item)"
            >
              <span>{{
                $moment(props.item.paidDateTime).format("MM/DD/YYYY")
              }}</span>
              <v-chip
                class="ml-1 pointer"
                @click="openStripe(props.item)"
                small="small"
                color="#D0E9FF"
                v-if="props.item.stripePaymentID &amp;&amp; props.item.stripePaymentID.substring(0, 3) === 'ch_'"
              >
                <v-icon small="small" color="#3C4DA6">credit_card</v-icon>
              </v-chip>
              <v-chip
                class="ml-1"
                small="small"
                dark="dark"
                color="#ffd0d2"
                v-else="v-else"
              >
                <v-icon small="small" color="#ff3840">attach_money</v-icon>
              </v-chip>
            </td>
            <td
              class="text-xs-left"
              v-else="v-else"
              @click="viewInvoice(props.item)"
            >
              <v-chip color="error" text-color="white" small="small"
                >Not Paid</v-chip
              >
            </td>
            <td class="text-xs-left" @click="viewInvoice(props.item)">
              {{ $moment(props.item.chargeDateTime).format("MM/DD/YYYY") }}
            </td>
            <td
              class="text-xs-center"
              v-if="props.item.collectCounter < 1"
              @click="viewInvoice(props.item)"
            >
              {{ props.item.collectCounter }}
            </td>
            <td
              class="text-xs-center"
              v-else="v-else"
              @click="viewInvoice(props.item)"
            >
              <v-chip color="warning" text-color="white" small="small">{{
                props.item.collectCounter
              }}</v-chip>
            </td>
            <td class="text-xs-right" @click="viewInvoice(props.item)">
              {{
                (parseFloat(props.item.invoiceAmount) +
                  parseFloat(props.item.taxAmount))
                  | currency
              }}
            </td>
            <td class="justify-end layout px-0">
              <v-menu bottom="bottom" left="left" offset-y="offset-y">
                <v-btn slot="activator" icon="icon">
                  <v-icon>more_vert</v-icon>
                </v-btn>
                <v-list class="menu-button">
                  <v-list-tile @click="viewInvoice(props.item)">
                    <v-list-tile-title>{{
                      $t("buttons.view")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-divider></v-divider>
                  <v-list-tile
                    v-if="!props.item.paidDateTime"
                    :to="`/invoice/edit/${props.item.invoiceID}`"
                  >
                    <v-list-tile-title>{{
                      $t("buttons.edit")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="checkRightStatus(51) &amp;&amp; props.item.paidDateTime"
                    :to="`/invoice/edit/${props.item.invoiceID}`"
                  >
                    <v-list-tile-title>{{
                      $t("buttons.editPaidInvoice")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <v-list-tile
                    v-if="!props.item.paidDateTime"
                    @click="deleteInvoice(props.item)"
                  >
                    <v-list-tile-title>{{
                      $t("buttons.delete")
                    }}</v-list-tile-title>
                  </v-list-tile>
                  <Payment
                    v-if="!props.item.paidDateTime"
                    :invoice="props.item"
                    @refresh="getList"
                    @save="save"
                  >
                  </Payment>
                  <div v-if="props.item.paidDateTime">
                    <div v-if="!props.item.refunded">
                      <div
                        v-if="
                          props.item.stripePaymentID == '' ||
                          props.item.stripePaymentID
                        "
                      >
                        <div
                          v-if="props.item.stripePaymentID &amp;&amp; props.item.stripePaymentID.substring(0, 3) == 'ch_'"
                        >
                          <v-list-tile @click="refundInvoice(props.item)">
                            <v-list-tile-title>{{
                              $t("buttons.refund")
                            }}</v-list-tile-title>
                          </v-list-tile>
                        </div>
                        <div v-else="v-else">
                          <v-list-tile @click="refundInvoice(props.item)">
                            <v-list-tile-title>{{
                              $t("buttons.markUnPaid")
                            }}</v-list-tile-title>
                          </v-list-tile>
                        </div>
                      </div>
                    </div>
                  </div>
                  <v-divider></v-divider>
                  <v-list-tile @click="emailInvoice(props.item)">
                    <v-list-tile-title>{{
                      $t("buttons.emailInvoice")
                    }}</v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning"
          >Your search for "{{ search }}" found no results.</v-alert
        >
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
const Create = () => import("./Create");
const Edit = () => import("./Edit");
const Payment = () => import("./Payment");
const Refund = () => import("./Refund");
import invoiceService from "../service.js";
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      headers: [
        {
          text: this.$t("labels.invoiceNumber"),
          value: "invoiceID",
          sortable: true,
          align: "center",
        },
        {
          text: this.$t("labels.createdAt"),
          value: "createDateTime",
          sortable: true,
          align: "center",
        },
        {
          text: this.$t("labels.paidDate"),
          value: "paidDateTime",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("labels.chargeDate"),
          value: "chargeDateTime",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("labels.collectCount"),
          value: "collectCounter",
          align: "center",
          sortable: true,
        },
        {
          text: this.$t("labels.invoiceAmount"),
          value: "invoiceAmount",
          align: "center",
          sortable: true,
        },
        {
          text: "",
          value: "action",
          sortable: false,
        },
      ],
      search: null,
      refundDialog: false,
      selectedInvoice: null,
      invoice: [],
      loading: true,
      pagination: {
        rowsPerPage: 10,
        sortBy: "invoiceID",
        descending: true,
      },
    };
  },
  computed: {
    ...mapGetters("location", ["location"]),
    ...mapGetters("global", ["currentUser", "checkRightStatus"]),
  },
  watch: {
    location() {
      this.getList();
    },
  },
  activated() {
    this.getList();
  },
  mounted() {
    this.$events.listen("refreshInvoiceList", (data) => this.getList());
  },
  created() {
    this.getList();
  },
  beforeDestroy() {
    this.$events.$off("refreshInvoiceList");
  },
  components: {
    Create,
    Refund,
    Edit,
    Payment,
  },
  methods: {
    ...mapActions("location", ["setLocation"]),
    emailInvoice(val) {
      this.$swal({
        title: "Are you sure?",
        text: "You want to email this invoice?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "No",
        confirmButtonText: "Yes",
      }).then((result) => {
        if (result.value) {
          this.$Progress.start();
          return invoiceService
            .emailInvoice(val.invoiceID, { email: this.location.invoiceEmail })
            .then((response) => {
              console.log("email response", response);
              if (response.data) {
                this.$swal
                  .mixin({
                    toast: true,
                    position: "top-end",
                    showConfirmButton: false,
                    timer: 3000,
                  })
                  .fire({
                    type: "success",
                    title: "Email was send successfully",
                  });
                this.$Progress.finish();
              }
            })
            .catch((error) => {
              this.$toasted.error(error.data.message, {
                position: "top-right",
                showHideTransition: "slide",
                icon: "error",
                duration: 5000,
              });
              this.$Progress.fail();
            });
        }
      });
    },
    refundInvoice(val) {
      this.selectedInvoice = val;
      this.refundDialog = true;
    },
    invoiceRefunded() {
      this.closeRefund();
      this.getList();
    },
    openStripe(val) {
      window.open(
        `https://dashboard.stripe.com/payments/${val.stripePaymentID}`,
        "_blank"
      );
    },
    save() {
      this.setLocation(this.location.storeID);
      this.getList();
    },
    closeRefund() {
      this.refundDialog = false;
    },
    async deleteInvoice(item) {
      const { value: text } = await this.$swal.fire({
        title: "Reason you want to delete invoice.",
        input: "textarea",
        inputPlaceholder: "Type your message here...",
        showCancelButton: true,
      });
      if (text) {
        let data = {
          reason: text,
          userID: this.currentUser.userID,
        };
        return invoiceService
          .invoiceDelete(item.invoiceID, data)
          .then((result) => {
            if (result.status) {
              this.$toasted.success("Invoice was deleted", {
                position: "top-right",
                showHideTransition: "slide",
                duration: 2000,
              });
              this.getList();
            }
          })
          .catch((err) => {
            this.$swal
              .mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
              })
              .fire({
                type: "error",
                title: err.data.data,
              });
          });
      }
    },
    add() {
      this.createDialog = true;
    },
    closeEdit() {
      this.editDialog = false;
    },
    close() {
      this.createDialog = false;
    },
    updated() {
      // this.$emit("created");
      this.getList();
      this.close();
    },
    created() {
      // this.$emit("created");
      this.getList();
      this.closeEdit();
    },
    viewInvoice(data) {
      // this.$router.push({path: `/global/invoice/${data.invoiceID}/view`});
      let routeData = this.$router.resolve({
        path: `/global/invoice/${data.invoiceID}/view`,
      });
      window.open(routeData.href, "newwindow", "width=800, height=950");
    },
    getList() {
      this.loading = true;
      return invoiceService.getById(this.location.storeID).then((response) => {
        this.invoice = response.data;
        this.loading = false;
        return response;
      });
    },
  },
};
</script>

<style scoped>
</style>